import axios from "axios";
import React, { Component,useEffect } from "react";

import { connect } from "react-redux";
import {set_datapage} from '../../redux/actions/DataPageAction'
import { baseUrl,localUrl } from "../../helpers/Url";
import "../../css/reportes/fichaespecie.css";

function Flecha(props){
    if (props.ultimo==undefined || !props.ultimo) {
        return (<span className="icon"><i className="mdi mdi-arrow-right"></i></span>)
    }else{
        return "";
    }

}
function Taxonjerarquia(props) {
  
    if (props.item!=undefined && props.item!="") {
        return (
            <>
            <span>{props.item}</span> 
            <Flecha ultimo={props.ultimo}/>
            </>
        );
        
    }else{
        return "";
    }
    
  }
class Recursoscites2 extends Component {
    
    constructor (props) {
        super(props)
        this.props.set_datapage('Ficha de Exportaciones')
        this.state = {
            ficha: false,
            imports: false,
            recursos: false,
            lista : false,
            regpag:process.env.REG_PAG    
          };
        this.search={txt_ncc:"",sel_cites: "", sel_iucn: ""}     
       
    }
    componentDidMount() {
        var url=baseUrl(`cites/reportes/listaexportaciones?`)
    
        url+="&i="+this.props.match.params.idespecie
       
        axios.get(url).then(res => {
            this.initpage(res.data);
        })
    }
    initpage(result){
        var resultados = result;        
        console.info("%c--- get reporte ", "color:yellow;background:green");
        
       
        this.setState({
            ficha: resultados.datos[0],
            imports: resultados.imports,
            recursos: resultados.recursos,
            lista: resultados.listadatos.values(),
            lista2: resultados.listadatos2.values()
        })

        this.llenarlista(resultados.listadatos)
        //this.cargarregistros(resultados.datos);
       
        
    }


    llenarlista(lista){
        if(lista.length>0){
            console.log(lista[0]);
            let yearAux = lista[0].exp_int_year
            let expAux = lista[0].exp_txt_importer
            /*
            const ElementoLista = lista.map((item, index) => 
                <tr key={index}>
                    <th> {index+1}  </th>
                    <th>{item.exp_int_year} </th>
                    <th>{item.exp_txt_term}</th>
                    <th>{item.exp_int_quantity}</th>
                    <th>{item.exp_txt_exporter}</th>                                       
                    <th>{item.exp_txt_importer}</th>
    
                </tr>
            )*/
            let colspanYear;
            let colspanExportador;
            const ElementoLista = lista.map((item, index) =>{
    
    
                colspanYear = lista.filter(item => item.exp_int_year==yearAux).length
                colspanExportador = lista.filter(item => item.exp_txt_exporter==expAux).length
                console.log(colspanYear)
                return (<tr>
                    <td> {index+1}  </td>
                    <td >{item.exp_int_year} </td>
                    <td>{item.exp_txt_term}</td>
                    <td>{item.exp_int_quantity}</td>
                    <td>{item.exp_txt_unit}</td>
                    <td>{item.exp_txt_exporter}</td>                                       
                    <td >{item.exp_txt_importer}</td>
                </tr>)
            });
            this.setState({lista : ElementoLista})
        }
        else{
            const ElementoLista = <tr>
            <td > -  </td>
            <td colSpan="6">No hay exportadores </td>
        </tr>
         this.setState({lista : ElementoLista})
        }
        

        
    }
    
   
    ir_detalle = (e) => {
        const { recurso } = e.target.dataset;
        var url="/reportes/listaespecies?q4="+recurso
        this.props.history.push(localUrl(url)) 
        
    }

   

    render() {
        return (
            <div>
                <section className="section is-main-section">
                    <div className="card has-table">                  
                        <div className="section profile-heading">
                            <div className="columns is-mobile is-multiline">
                                <div className="column is-2">
                                <span className="header-icon user-profile-image">
                                        <img alt=""  src={baseUrl("imagen/")+this.state.ficha.pli_txt_scientificname+".jpg"}></img>
                                </span>
                                </div>
                                <div className="column is-4-tablet is-10-mobile name">
                                <p>
                                    <br></br>
                                    <span className="title is-bold">{this.state.ficha.pli_txt_scientificname}</span>
                                    <p className="taxon-jerarquia">
                                       <Taxonjerarquia item={this.state.ficha.pli_txt_kingdom}/>
                                       <Taxonjerarquia item={this.state.ficha.pli_txt_phylum}/>
                                       <Taxonjerarquia item={this.state.ficha.pli_txt_class}/>
                                       <Taxonjerarquia item={this.state.ficha.pli_txt_order}/>
                                       <Taxonjerarquia item={this.state.ficha.pli_txt_family}/>
                                       <Taxonjerarquia item={this.state.ficha.pli_txt_genus} ultimo={true}/>
                                    </p>
                                    
                                    
                                </p>
                                </div>
                                {this.state.ficha.pli_txt_cite!=null&&this.state.ficha.pli_txt_cite!=""? (
                                     <div className="column is-2-tablet is-4-mobile has-text-centered">
                                     <p className="stat-val">{this.state.ficha.pli_txt_cite.toUpperCase() }</p>
                                     <p className="stat-key">APPENDICES</p>
                                     </div>
                                ) : ("")}
                                {this.state.ficha.pli_txt_uicncountry!=null&&this.state.ficha.pli_txt_uicncountry!=""? (
                                     <div className="column is-2-tablet is-4-mobile has-text-centered">
                                     <p className="stat-val">{this.state.ficha.pli_txt_uicncountry.toUpperCase() }</p>
                                     <p className="stat-key">UICN Nacional</p>
                                     </div>
                                ) : ("")}
                                {this.state.ficha.pli_txt_uicn!=null&&this.state.ficha.pli_txt_uicn!=""? (
                                     <div className="column is-2-tablet is-4-mobile has-text-centered">
                                     <p className="stat-val">{this.state.ficha.pli_txt_uicn.toUpperCase() }</p>
                                     <p className="stat-key">UICN</p>
                                     </div>
                                ) : ("")}
                               
                               
                            </div>
                        </div>
                    </div>
                    <div className="tile is-ancestor">
                        <div className="tile is-parent">
                            <div className="card tile is-child">
                            <header className="card-header">
                                <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-account-circle default"></i></span>
                                Detalle
                                </p>
                            </header>
                            <div className="card-content">
                            <table className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                                <thead>
                                <tr>
                                    <th> #  </th>
                                    <th>Año</th>
                                    <th>Presentacion</th>   
                                    <th>Cantidad</th>
                                    <th>Unidad de Medida</th>                                   
                                    <th>Exportador</th>
                                    <th>Importador</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {this.state.lista}                          
                                </tbody>
                                </table>  
                            </div>
                        </div>
                        <div className="tile is-parent">
                        </div>
                        </div>
                </div>
                </section>
            </div>
        )
    }
}

const md = state => {

}
export default connect(null, {set_datapage})(Recursoscites2)